module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic01.b686b56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic01.png
// module id = 466
// module chunks = 1